import React from 'react';
import './FormInput.css';

const ExamplesInput = ({ value, onChange }) => {
  return (
    <div className="form-input-group full-width">
      <label className="form-label">Examples / Reference (optional)</label>
      <textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="form-textarea"
        placeholder="Provide examples or references"
        rows="4"
      />
    </div>
  );
};

export default ExamplesInput;

